// Shared presentational primitives.

import { useState } from 'react';

export function Spinner({ label }: { label?: string }) {
  return (
    <span className="row row-tight row-center">
      <span className="spinner" />
      {label ? <span className="muted small">{label}</span> : null}
    </span>
  );
}

export function ErrorMessage({ error }: { error: unknown }) {
  if (!error) return null;
  const message = error instanceof Error ? error.message : String(error);
  return <div className="alert alert-error">{message}</div>;
}

/** Copy-to-clipboard box for commands and keys. */
export function CopyBox({ value, masked = false }: { value: string; masked?: boolean }) {
  const [copied, setCopied] = useState(false);
  const [revealed, setRevealed] = useState(!masked);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // Clipboard access can be blocked; selecting the text still works.
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };

  const shown = revealed ? value : `${value.slice(0, 6)}${'•'.repeat(Math.max(value.length - 6, 8))}`;

  return (
    <div className={`copy-box${masked ? ' copy-box-masked' : ''}`}>
      <pre className="copy-box-content">
        <code>{shown}</code>
      </pre>
      <div className="copy-box-actions">
        {masked ? (
          <button type="button" className="btn btn-ghost btn-sm" onClick={() => setRevealed((v) => !v)}>
            {revealed ? 'Hide' : 'Show'}
          </button>
        ) : null}
        <button type="button" className="btn btn-sm" onClick={copy}>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </div>
  );
}
